import WebApp from '@twa-dev/sdk';
import { API_URL, TELEGRAM_BOT_USERNAME, TELEGRAM_BOT_TOKEN } from '../config/env';
import { isAccessTokenValid } from './auth';

// Get environment variables from centralized config
const BOT_TOKEN = TELEGRAM_BOT_TOKEN;
const BOT_USERNAME = TELEGRAM_BOT_USERNAME;

export const initializeTelegramApp = async () => {
  // Initialize the Web App
  WebApp.ready();
  
  // Enable closing confirmation
  WebApp.enableClosingConfirmation();
  
  // Set the header color to match our theme
  WebApp.setHeaderColor('#FF0000');
  
  // Set the background color
  WebApp.setBackgroundColor('#0F2231');
  
  // Log initialization for debugging
  console.log('Telegram WebApp initialized');
  console.log('Bot username:', BOT_USERNAME);

  // Expand the WebApp and disable vertical swipes
  WebApp.expand();
  
  // Check if we're in Telegram environment before calling Telegram-specific methods
  if (window.Telegram && window.Telegram.WebApp) {
    window.Telegram.WebApp.disableVerticalSwipes();
  }

  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason?.message?.includes('Session expired')) {
      WebApp.showAlert('Session expired. Please reopen the WebApp.');
    }
  });
  
  await loginWithTelegram();
  
  // Return the user info
  return getTelegramUser();
};

export const isTelegramWebApp = () => {
  // Check if the app is running inside the Telegram WebApp environment
  return !!WebApp.initData;
};

async function loginWithTelegram() {
  if (isAccessTokenValid()) {
    return;
  }

  const initData = WebApp.initData;

  const res = await fetch(`${API_URL}/auth/login`, {
    method: 'POST',
    headers: {
      'Authorization': `tma ${initData}`,
    },
  });

  if (!res.ok) throw new Error('Login failed');

  const { accessToken, refreshToken } = await res.json();
  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('refreshToken', refreshToken);
}


export const getTelegramUser = () => {
  if (!WebApp.initDataUnsafe?.user) {
    return null;
  }

  const user = {
    id: WebApp.initDataUnsafe.user.id,
    username: WebApp.initDataUnsafe.user.username,
    firstName: WebApp.initDataUnsafe.user.first_name,
    lastName: WebApp.initDataUnsafe.user.last_name,
    photoUrl: WebApp.initDataUnsafe.user.photo_url,
  };
  
  return user;
};

export const showAlert = (message: string) => {
  WebApp.showAlert(message);
};

export const showConfirm = (message: string, callback: (confirmed: boolean) => void) => {
  WebApp.showConfirm(message, callback);
};

export const openLink = (url: string) => {
  WebApp.openLink(url);
};

export const closeWebApp = () => {
  WebApp.close();
};

export const expandWebApp = () => {
  WebApp.expand();
};

export default {
  initializeTelegramApp,
  isTelegramWebApp,
  getTelegramUser,
  showAlert,
  showConfirm,
  openLink,
  closeWebApp,
  expandWebApp,
};
